import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Iletisim() {
  // --- AOS VE SAYFA BAŞLIĞI AYARI ---
  useEffect(() => {
    document.title = "İletişim & Arıza Kaydı | Ankara Merkez Teknik";
    
    window.scrollTo(0, 0);
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
  }, []);

  // Form verilerini tutacağımız State yapısı
  const [formData, setFormData] = useState({
    ad: '',
    telefon: '',
    ilce: '',
    hizmet: '',
    detay: ''
  });

  // Inputlara yazıldıkça state'i güncelleyen fonksiyon
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // WhatsApp yönlendirme fonksiyonu
  const handleWhatsAppSubmit = (e) => {
    e.preventDefault();

    const mesaj = `Merhaba Ankara Merkez Teknik, internet sitenizden yeni bir arıza kaydı talebim var:

👤 *Ad Soyad:* ${formData.ad}
📱 *Telefon:* ${formData.telefon}
📍 *İlçe/Semt:* ${formData.ilce}
🔧 *Hizmet Türü:* ${formData.hizmet}
📝 *Arıza Detayı:* ${formData.detay}
`;

    // Sabit hattın WhatsApp Business desteği varsa bu formatta tıkır tıkır çalışır
    const telefonNumarasi = "903125810881"; 
    const whatsappUrl = `https://wa.me/${telefonNumarasi}?text=${encodeURIComponent(mesaj)}`;
    window.open(whatsappUrl, '_blank');
  };

  // --- GOOGLE İÇİN İLETİŞİM SAYFASI ŞEMASI (JSON-LD) ---
  const contactSchema = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "mainEntity": {
      "@type": "LocalBusiness",
      "name": "Ankara Merkez Teknik",
      "telephone": "+903125810881",
      "email": "info@ankaramerkezteknik.com",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Ankara",
        "addressCountry": "TR"
      },
      "openingHours": "Mo-Su 00:00-23:59"
    }
  };

  return (
    <div className="contact-page-wrapper">
      <Helmet>
        <title>İletişim & Arıza Kaydı | Ankara Merkez Teknik</title>
        <meta name="description" content="Ankara kombi, beyaz eşya ve klima servisi için bize ulaşın. 7/24 acil teknik servis hattımızla aynı gün garantili onarım sağlıyoruz." />
        <script type="application/ld+json">
          {JSON.stringify(contactSchema)}
        </script>
      </Helmet>

      <section className="contact-content-section simple-mode">
        <div className="contact-container">
          
          <div className="contact-simple-header" data-aos="fade-down">
            <span className="saas-subtitle">Bize Ulaşın</span>
            <h1 className="saas-main-title">Yanınızdayız.</h1>
            <p className="contact-lead-text">
              Cihazınızla ilgili yaşadığınız her türlü teknik problemde uzman kadromuzla bir telefon uzağınızdayız. 
              Formu doldurun veya direkt arayın, aynı gün çözüm üretelim.
            </p>
          </div>

          <div className="contact-grid-layout">
            
            {/* SOL: İLETİŞİM KARTLARI */}
            <div className="contact-info-side" data-aos="fade-right" data-aos-delay="200">
              <div className="contact-cards-grid">
                
                <div className="c-card">
                  <div className="c-icon">☎️</div>
                  <div className="c-details">
                    <h4>Çağrı Merkezi</h4>
                    <a href="tel:03125810881">0312 581 08 81</a>
                  </div>
                </div>

                <div className="c-card whatsapp-card">
                  <div className="c-icon">💬</div>
                  <div className="c-details">
                    <h4>WhatsApp Acil Destek</h4>
                    <a href="https://wa.me/903125810881" target="_blank" rel="noreferrer">Mesaj Gönder</a>
                  </div>
                </div>

                <div className="c-card">
                  <div className="c-icon">✉️</div>
                  <div className="c-details">
                    <h4>E-Posta</h4>
                    <a href="mailto:info@ankaramerkezteknik.com">info@ankaramerkezteknik.com</a>
                  </div>
                </div>

                <div className="c-card">
                  <div className="c-icon">⏱️</div>
                  <div className="c-details">
                    <h4>Çalışma Saatleri</h4>
                    <span>7/24 Gezici Servis</span>
                  </div>
                </div>

              </div>
            </div>

            {/* SAĞ: WHATSAPP ENTEGRELİ FORM */}
            <div className="contact-form-side" data-aos="fade-left" data-aos-delay="400">
              <div className="form-wrapper">
                <h3>Hızlı Arıza Kaydı Oluşturun</h3>
                
                <form className="saas-contact-form" onSubmit={handleWhatsAppSubmit}>
                  
                  <div className="form-group">
                    <label>Adınız Soyadınız</label>
                    <input type="text" name="ad" value={formData.ad} onChange={handleChange} placeholder="Örn: Enes Buğra" required />
                  </div>

                  <div className="form-row">
                    <div className="form-group">
                      <label>Telefon Numaranız</label>
                      <input type="tel" name="telefon" value={formData.telefon} onChange={handleChange} placeholder="05XX XXX XX XX" required />
                    </div>
                    <div className="form-group">
                      <label>İlçe / Semt</label>
                      <input type="text" name="ilce" value={formData.ilce} onChange={handleChange} placeholder="Örn: Keçiören" required />
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Hizmet Türü</label>
                    <div className="select-wrapper">
                      <select name="hizmet" value={formData.hizmet} onChange={handleChange} required>
                        <option value="">Lütfen Seçiniz...</option>
                        <option value="Kombi Teknik Servis">Kombi Teknik Servis</option>
                        <option value="Klima Teknik Servis">Klima Teknik Servis</option>
                        <option value="Buzdolabı Teknik Servis">Buzdolabı Teknik Servis</option>
                        <option value="Çamaşır Makinesi Servisi">Çamaşır Makinesi Servisi</option>
                        <option value="Bulaşık Makinesi Servisi">Bulaşık Makinesi Servisi</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group">
                    <label>Arıza Detayı</label>
                    <textarea name="detay" value={formData.detay} onChange={handleChange} rows="4" placeholder="Cihazınızdaki problemi kısaca açıklayın..." required></textarea>
                  </div>

                  <button type="submit" className="btn-primary form-submit-btn">TALEBİ WHATSAPP İLE GÖNDER</button>
                </form>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default Iletisim;